import React, { useState } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown 
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div 
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 pb-6' : 'max-h-0'
        }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const LSGFaqs = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What is Maxiom Wealth's LSG Framework?",
      answer: "The LSG Framework stands for Liquidity, Safety, and Growth. It's our proprietary approach to asset allocation that ensures your investments are structured according to your financial needs and goals. Each component serves a specific purpose: Liquidity for immediate needs, Safety for capital protection, and Growth for long-term wealth creation."
    },
    {
      question: "How does the Liquidity (L) component work?",
      answer: "The Liquidity component is your financial cushion, typically allocated to ultra-short debt funds or short-term FDs. It ensures you have easy access to funds for emergencies, planned expenses, or short-term needs without having to liquidate your long-term investments during market downturns."
    },
    {
      question: "What types of investments are included in the Safety (S) bucket?",
      answer: "The Safety component focuses on capital preservation through high-quality debt instruments, conservative hybrid strategies, or capital-protected structures. This portion of your portfolio is designed to protect your capital while still providing reasonable returns, especially for medium-term goals like buying a house or funding education."
    },
    {
      question: "How does the Growth (G) component generate wealth?",
      answer: "The Growth component leverages our proprietary Roots & Wings philosophy to build wealth over time. We focus on high-quality equity investments with strong balance sheets (Roots) and consistent growth potential (Wings). This approach ensures your portfolio is built on solid fundamentals while maximizing compounding opportunities."
    },
    {
      question: "Is the LSG Framework customizable for different investors?",
      answer: "Absolutely! The LSG Framework is highly personalized based on your age, risk profile, cash flow requirements, and financial goals. For example, a younger entrepreneur might have a 10% Liquidity, 20% Safety, 70% Growth allocation, while a retiree might have 20% Liquidity, 50% Safety, and 30% Growth. Our SEBI-registered advisors tailor the framework to match your unique financial situation."
    }
  ];

  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Understanding the LSG Framework
            </h2>
            <p className="text-gray-600 mb-8">
              Learn more about our proprietary research model that helps us identify high-quality mutual funds with the greatest potential for stable, long-term performance.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LSGFaqs;